import moment from 'moment';
import React, { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';

const DatePicker = ({date,onChange, minDate=null}) => {
    const [datestate,setDatestate]=useState(new Date())
    useEffect(()=>{
        if(date)setDatestate(moment(date).toDate())
    },[date])
  const onCHangeDate=(val)=>{
    setDatestate(val)
    if(onChange)onChange(moment(val))
  }
  return (
    <div>
    <Calendar className={'custom-datepicker'} minDate={minDate} maxDate={new Date()} onChange={onCHangeDate} value={datestate} />
  </div>
  )
}

export default DatePicker
